<script>
  let open = false
  let className=""
  export { className as class }
  const toggle = ()=> open=!open
</script>


<div class="dropdown {className}">
  <span on:click={toggle}>
    <slot>Menu</slot>
  </span>
  {#if open}
    <div class="pop-backdrop" on:click={(e)=> open=false} ></div>
    <div class="dropdown-menu" on:click={(e)=> open=false}>
      <slot name="menu"></slot>
    </div>
  {/if}
</div>

<style>
  * {
    white-space: normal;
    -webkit-user-modify:read-only;
  }
  .dropdown{
    display:inline-block;
  }

  .dropdown-menu{
    display:block;
    position:absolute;
    z-index:10;
  }
  :global(duo-dropdown [slot="menu"] a,.dropdown-menu [slot="menu"] a,.dropdown-menu [slot="menu"] button){
    display: block;
    padding: 3px 20px;
    clear: both;
    font-weight: normal;
    line-height: 1.428571429;
    color: #333;
    white-space: nowrap;
    background:white;
    width:100%;
    text-align:left;
    border:0px;
    font-size:14px;
  }
  :global(duo-dropdown [slot="menu"] a:hover,.dropdown-menu [slot="menu"] a:hover,.dropdown-menu [slot="menu"] button:hover){
    text-decoration: none;
    color: #303030;
    background-color: #f5f5f5;
  }
  .pop-backdrop{
    position: fixed;
    left:0;
    right:0;
    bottom:0;
    top:0;
    background:rgba(0,0,0,0.01)
  }

</style>